import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Breadcrumb,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Spin,
  Table,
  Tooltip,
} from "antd";
import { ErrorNotificationMsg } from "../../utils/Notifications";
import {
  getRequest,
  getRequest1,
  patchRequest,
  postRequest,
} from "../../axios";
import { authUserData } from "../../utils/Helper";
import { FilterFilled } from "@ant-design/icons";
import { ReactComponent as RupeesSign } from "../../image/RupeesSign.svg";
import ButtonField from "../../common/htmlComponents/ButtonField";
import ExelDownload from "../../image/exeldownload.svg";
// let initialRender = true;

const Comparatives = () => {
  const { t } = useTranslation();
  const { Option } = Select;
  const navigate = useNavigate();
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const [reload, setReload] = useState(false);
  const [siteName, setSiteName] = useState([]);
  const [materialName, setMaterialName] = useState([]);
  const [enableInputs, setEnableInputs] = useState(false);
  const { id } = useParams();
  const { Search } = Input;
  const [totalCount, settotalCount] = useState(0);
  const [rfqHistory, setRFQHistory] = useState([]);
  const [categoryTree, setCategoryTree] = useState([]);
  const [siteDetails, setSiteDetails] = useState(null);
  const [initialRender, setInitialRender] = useState(true);
  const formRef = useRef();

  const [loading, setLoading] = useState(false);
  const [apiLoading, setapiLoading] = useState(false);
  const [state, setState] = useState({
    // page: 1,
    // ordering: "id",
    // pagesize: 10,
    // search: "",
    // total: 0,
    hide_r0_price: false,
    hide_r1_price: false,
    hide_r_price: false,
    site_id: [],
    material_type_id: [],
  });

  const [hideInitialBidPrice, sethideInitialBidPrice] = useState(false);
  const [hideR1BidPrice, setHideR1BidPrice] = useState(false);
  const [hideRBidPrice, setHideRBidPrice] = useState(false);
  const [showUnitRateCementR1, setShowUnitRateCementR1] = useState(false);
  const [showUnitRateCementR, setShowUnitRateCementR] = useState(false);
  const [isFinalBidPrice, setIsFinalBidPrice] = useState(false);
  const [showAdditionalCheckboxesFinal, setShowAdditionalCheckboxesFinal] =
    useState(true);
  const [showAdditionalCheckboxes, setShowAdditionalCheckboxes] =
    useState(false);
  const [comparativesRFQ, setComparativesRFQ] = useState([]);
  const [rfqNumber, setRfqNumber] = useState(null);

  useEffect(() => {
    const getVendorBidRFQ = async () => {
      setapiLoading(true);
      try {
        const response = await patchRequest(
          `comparative-rfq/${id}/get-comparative-details-by-site-wise/`
        );
        if (response.data.data) {
          const responseData =
            response?.data?.data?.comparative_details_by_rfq_site_wise;
          const tableData = responseData?.map((item, index) => ({
            key: index + item.rfq_site_name_id,
            siteName: item?.rfq_site_name,
            siteLocations: item?.rfq_material_details?.map((item1) => ({
              materialName: item1?.rfq_material_type_name,
              quantity: item1?.rfq_material_type_total_quantity,
              uom: item1?.rfq_material_type_uom,
              vendorBids: item1?.rfq_material_wise_bid_rfq_details?.map(
                (item2) => ({
                  vendorName: item2?.vendor_name,
                  r0_price: item2?.vendor_bid_rfq_details?.map((item3) => ({
                    r0_unit_price: item3?.r0_price?.[0]?.r0_unit_price,
                    r0_total_price: item3?.r0_price?.[0]?.r0_total_price,
                  })),
                  r1_price: item2?.vendor_bid_rfq_details?.map((item3) => ({
                    r1_unit_price: item3?.r1_price?.[0]?.r1_unit_price,
                    r1_total_price: item3?.r1_price?.[0]?.r1_total_price,
                  })),
                  r_price: item2?.vendor_bid_rfq_details?.map((item3) => ({
                    r_unit_price: item3?.r_price?.[0]?.r_unit_price,
                    r_total_price: item3?.r_price?.[0]?.r_total_price,
                  })),
                })
              ),
            })),
          }));
          setComparativesRFQ(tableData);
          setRfqNumber(response.data.data.rfq_number);
          const sites =
            response.data.data.comparative_details_by_rfq_site_wise.map(
              (item) => ({
                id: item.rfq_site_name_id,
                name: item.rfq_site_name,
              })
            );
          setSiteName(sites);

          const materialTypes =
            response.data.data.comparative_details_by_rfq_site_wise.flatMap(
              (item) =>
                item.rfq_material_details.map((material) => ({
                  id: material.rfq_material_type_id,
                  name: material.rfq_material_type_name,
                }))
            );

          const uniqueMaterialTypes = materialTypes.filter(
            (material, index, self) =>
              index ===
              self.findIndex(
                (m) => m.id === material.id && m.name === material.name
              )
          );
          setMaterialName(uniqueMaterialTypes);
        } else {
          ErrorNotificationMsg(t("Error in Comparatives"));
        }
        setapiLoading(false);
      } catch (error) {
        console.error("Error:", error);
        setapiLoading(false);
      }
    };
    getVendorBidRFQ();
  }, [id]);

  const handleCheckboxChange = () => {
    setIsFinalBidPrice(!isFinalBidPrice);
    setShowAdditionalCheckboxesFinal(true);

    setState((prevState) => ({
      ...prevState,
      is_final_bid_price: !isFinalBidPrice,
    }));
  };

  const handleCheckboxhideR1 = () => {
    sethideInitialBidPrice(!hideInitialBidPrice);
  };

  const handleCheckboxhideR = () => {
    setHideR1BidPrice(!hideR1BidPrice);
  };

  const handleCheckboxhideRR = () => {
    setHideRBidPrice(!hideRBidPrice);
  };

  const updateState = async () => {
    try {
      const payload = {
        ...state,
        // hide_r0_price: false,
        // hide_r1_price: false,
        // hide_r_price: false,
        site_id: state.site_id,
      };
      const response = await patchRequest(
        `comparative-rfq/${id}/get-comparative-details-by-site-wise/`,
        payload
      );
      if (response.data.data) {
        const responseData =
          response?.data?.data?.comparative_details_by_rfq_site_wise;
        const tableData = responseData?.map((item, index) => ({
          key: index + item.rfq_site_name_id,
          siteName: item?.rfq_site_name,
          siteLocations: item?.rfq_material_details?.map((item1) => ({
            materialName: item1?.rfq_material_type_name,
            quantity: item1?.rfq_material_type_total_quantity,
            uom: item1?.rfq_material_type_uom,
            vendorBids: item1?.rfq_material_wise_bid_rfq_details?.map(
              (item2) => ({
                vendorName: item2?.vendor_name,
                r0_price: item2?.vendor_bid_rfq_details?.map((item3) => ({
                  r0_unit_price: item3?.r0_price?.[0]?.r0_unit_price,
                  r0_total_price: item3?.r0_price?.[0]?.r0_total_price,
                })),
                r1_price: item2?.vendor_bid_rfq_details?.map((item3) => ({
                  r1_unit_price: item3?.r1_price?.[0]?.r1_unit_price,
                  r1_total_price: item3?.r1_price?.[0]?.r1_total_price,
                })),
                r_price: item2?.vendor_bid_rfq_details?.map((item3) => ({
                  r_unit_price: item3?.r_price?.[0]?.r_unit_price,
                  r_total_price: item3?.r_price?.[0]?.r_total_price,
                })),
              })
            ),
          })),
        }));
        setComparativesRFQ(tableData);
        // setComparativesRFQ(response)
      } else {
        ErrorNotificationMsg(t("Error fetching site details"));
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
    }
  };

  const handleSiteNameSelectChange = async (value) => {
    const updatedState1 = { ...state, site_id: value };
    setState(updatedState1);

    // if(!initialRender){
    //   updateState();
    // }
  };
  useEffect(() => {
    if (initialRender) {
      setInitialRender(false);
    } else {
      updateState();
    }
  }, [state]);

  const handleMaterialSelectChange = async (value) => {
    const updatedState2 = { ...state, material_type_id: value };
    setState(updatedState2);
  };

  const handleUnitRateOfCementChangeR0 = (
    value,
    recordKey,
    siteIndex,
    gstRate,
    quantity
  ) => {
    const updatedComparativesRFQ = [...comparativesRFQ];
    const record = updatedComparativesRFQ.find(
      (item) => item.key === recordKey
    );
    const site = record.siteLocations[siteIndex];
    site.vendorBids[0].r0_price[0].r0_unit_price = value;
    site.vendorBids[0].r0_price[0].r0_total_price =
      ((value * (100 + gstRate)) / 100) * quantity;
    setComparativesRFQ(updatedComparativesRFQ);
  };

  const handleUnitRateOfFreightChangeR0 = (value, recordKey, siteIndex) => {
    const updatedComparativesRFQ = [...comparativesRFQ];
    const record = updatedComparativesRFQ.find(
      (item) => item.key === recordKey
    );
    const site = record.siteLocations[siteIndex];
    site.vendorBids[0].r0_price[0].r0_unit_price = value;
    site.vendorBids[0].r0_price[0].r0_total_price = value * site.quantity;
    setComparativesRFQ(updatedComparativesRFQ);
  };

  const handleTotalUnitRateR0Change = (value, recordKey, siteIndex) => {
    const updatedComparativesRFQ = [...comparativesRFQ];
    const record = updatedComparativesRFQ.find(
      (item) => item.key === recordKey
    );
    const site = record.siteLocations[siteIndex];
    site.vendorBids[0].r0_price[0].r0_total_price = value;
    site.vendorBids[0].r0_price[0].r0_unit_price = value / site.quantity;
    setComparativesRFQ(updatedComparativesRFQ);
  };
  const [enableInputsR1, setEnableInputsR1] = useState(false);

  const handleUnitRateOfCementChangeR1 = (value, recordKey, siteIndex) => {
    const updatedComparativesRFQ = [...comparativesRFQ];
    const record = updatedComparativesRFQ.find(
      (item) => item.key === recordKey
    );
    const site = record.siteLocations[siteIndex];
    site.vendorBids[0].r1_price[0].r1_unit_price = value;
    site.vendorBids[0].r1_price[0].r1_total_price = value * site.quantity;
    setComparativesRFQ(updatedComparativesRFQ);
  };

  const calculateTotalUnitRateOfCementR1 = (record) => {
    const totalUnitRateOfCementR1 = record.siteLocations.reduce(
      (total, site) =>
        total + (parseFloat(site.vendorBids[0].r1_price[0].r1_unit_price) || 0),
      0
    );
    return totalUnitRateOfCementR1.toFixed(2);
  };

  const handleUnitRateOfFreightChangeR1 = (value, recordKey, siteIndex) => {
    const updatedComparativesRFQ = [...comparativesRFQ];
    const record = updatedComparativesRFQ.find(
      (item) => item.key === recordKey
    );
    const site = record.siteLocations[siteIndex];
    site.vendorBids[0].r1_price[0].r1_unit_price = value;
    site.vendorBids[0].r1_price[0].r1_total_price = value * site.quantity;
    setComparativesRFQ(updatedComparativesRFQ);
  };

  const handleTotalUnitRateOfCementR1Change = (value, recordKey, siteIndex) => {
    const updatedComparativesRFQ = [...comparativesRFQ];
    const record = updatedComparativesRFQ.find(
      (item) => item.key === recordKey
    );
    const site = record.siteLocations[siteIndex];
    site.vendorBids[0].r1_price[0].r1_total_price = value;
    site.vendorBids[0].r1_price[0].r1_unit_price = value / site.quantity;
    setComparativesRFQ(updatedComparativesRFQ);
  };
  const renderUnitRateOfCementR0 = (siteLocations, record) => {
    return (
      <>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {siteLocations.map((site, siteIndex) => (
            <Input
              key={site.name + siteIndex}
              disabled={enableInputs}
              style={{ width: "300px" }}
              // placeholder={`Enter Unit Rate of Cement for ${site.name}`}
              value={site.vendorBids[0].r0_price[0].r0_unit_price}
              onChange={(e) =>
                handleUnitRateOfCementChangeR0(
                  e.target.value,
                  record.key,
                  siteIndex,
                  site.vendorBids[0].gst_rate,
                  site.quantity
                )
              }
              type="number"
            />
          ))}
        </div>
      </>
    );
  };

  const renderDateR0 = (siteLocations, record) => {
    return (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            marginBottom: "-30px",
          }}
        >
          {siteLocations.map((site, siteIndex) => (
            <Form.Item
              name={`initial_bid_price_date_${record.key}_${siteIndex}`}
              key={`${record.key}_${siteIndex}`}
            >
              <DatePicker
                showTime
                format="DD-MM-YYYY"
                // onChange={(date, dateString) => handleDatepickerChangeCementR0(dateString, record.key, siteIndex)}
                style={{ width: "100%" }}
                disabled
                //  value={state.bid_rfq_vendor_detail_All[record.key]?.bid_rfq_site_detail[siteIndex]?.initial_bid_price_date}
              />
            </Form.Item>
          ))}
        </div>
      </>
    );
  };

  const vendors = (siteLocations, record) => {
    return (
      <>
        <div style={{ display: "flex", gap: "10px" }}>
          {record.siteLocations.map((site, siteIndex) => (
            <div key={siteIndex}>
              {site.vendorBids.map((vendor, vendorIndex) => (
                <>
                  <Input
                    key={vendorIndex}
                    disabled={enableInputs}
                    style={{ width: "100%" }}
                    // placeholder={`Enter Unit Rate of Cement for ${site.name}`}
                    value={vendor.r0_price[0].r0_unit_price}
                    onChange={(e) =>
                      handleUnitRateOfCementChangeR0(
                        e.target.value,
                        record.key,
                        siteIndex,
                        vendor.gst_rate,
                        site.quantity
                      )
                    }
                    type="number"
                  />
                </>
              ))}
            </div>
          ))}
        </div>
      </>
    );
  };

  const renderVendorName = (siteLocations, record) => {
    return (
      <>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>

          {siteLocations.map((site, siteIndex) => (
            <Input
              key={site.name + siteIndex}
              disabled
              // prefix={<RupeesSign />}
              style={{ width: "100%" }}
              //placeholder={`Enter Unit Rate of Freight for ${site.name}`}
              // value={state.bid_rfq_vendor_detail_All[record.key].bid_rfq_site_detail.initial_bid_price_unit_rate_of_freight} // Assuming only one vendor and one site
              //   value={
              //     syncAllFreightR0
              //       ? state.bid_rfq_vendor_detail_All[record.key]?.bid_rfq_site_detail[siteIndex]?.initial_bid_price_unit_rate_of_freight
              //       : site.initial_bid_price_unit_rate_of_freight
              //   }
              //onChange={(e) => handleUnitRateOfFreightChangeR0(e.target.value, record.key, siteIndex)}
              type="number"
            />
          ))}
        </div>

        {/* <Input
        placeholder={`Total Unit Rate of Freight R0`}
        value={record.total_unit_rate_of_cement} // Assuming unit_rate_of_cement is a property in the record
        style={{ width: '300px', top: '10px' }} // Adjust width as needed
        disabled
      // Add onChange handler if needed
      
      /> */}
      </>
    );
  };

  const renderUnitRateOfTotalUnitRateR0 = (siteLocations, record) => {
    return (
      <>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>

          {siteLocations.map((site, siteIndex) => (
            <Input
              key={site.name + siteIndex}
              disabled
              prefix={<RupeesSign />}
              style={{ width: "100%" }}
              //placeholder={`Enter Total Unit Rate for ${site.name}`}
              //   value={
              //     parseFloat(state.bid_rfq_vendor_detail_All[record.key].bid_rfq_site_detail[siteIndex].initial_bid_price_unit_rate) && parseFloat(state.bid_rfq_vendor_detail_All[record.key].bid_rfq_site_detail[siteIndex].initial_bid_price_unit_rate_of_freight) ?
              //       (
              //         parseFloat(state.bid_rfq_vendor_detail_All[record.key].bid_rfq_site_detail[siteIndex].initial_bid_price_unit_rate) +
              //         parseFloat(state.bid_rfq_vendor_detail_All[record.key].bid_rfq_site_detail[siteIndex].initial_bid_price_unit_rate_of_freight)
              //       ).toFixed(2) // If both initial_bid_price_unit_rate and initial_bid_price_unit_rate_of_freight exist, display their total
              //       :
              //       (parseFloat(state.bid_rfq_vendor_detail_All[record.key].bid_rfq_site_detail[siteIndex].initial_bid_price_unit_rate) ?
              //         (
              //           parseFloat(state.bid_rfq_vendor_detail_All[record.key].bid_rfq_site_detail[siteIndex].initial_bid_price_unit_rate)).toFixed(2) // If only initial_bid_price_unit_rate exists, display it
              //         :
              //         (

              //           parseFloat(state.bid_rfq_vendor_detail_All[record.key].bid_rfq_site_detail[siteIndex].initial_bid_price_unit_rate_of_freight)
              //         ).toFixed(2) // If only initial_bid_price_unit_rate_of_freight exists, display it
              //       )}
              // onChange={(e) => handleTotalUnitRateR0Change(e.target.value, record.key, siteIndex)}
              type="number"
            />
          ))}
        </div>
      </>
    );
  };

  const calculateTotalUnitRateOfCementR0 = (record) => {
    const totalUnitRateOfCement = record.siteLocations.reduce(
      (total, site) =>
        total + (parseFloat(site.vendorBids[0].r0_price[0].r0_unit_price) || 0),
      0
    );
    return totalUnitRateOfCement.toFixed(2);
  };

  const renderUnitRateOfFreightR0 = (siteLocations, record) => {
    return (
      <>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {siteLocations.map((site, siteIndex) => (
            <Input
              key={site.name + siteIndex}
              disabled={enableInputs}
              style={{ width: "100%" }}
              placeholder={`Enter Unit Rate of Freight for ${site.name}`}
              value={site.vendorBids[0].r0_price[0].r0_unit_price}
              onChange={(e) =>
                handleUnitRateOfFreightChangeR0(
                  e.target.value,
                  record.key,
                  siteIndex
                )
              }
              type="number"
            />
          ))}
          <Input
            placeholder={`Total Unit Rate of Freight R0`}
            prefix={<RupeesSign />}
            value={calculateTotalUnitRateOfFreightR0(record)} // Assuming unit_rate_of_cement is a property in the record
            style={{ width: "100%" }} // Adjust width as needed
            disabled
          />
        </div>
      </>
    );
  };

  const calculateTotalUnitRateOfFreightR0 = (record) => {
    const totalUnitRateOfFreightR0 = record.siteLocations.reduce(
      (total, site) =>
        total + (parseFloat(site.vendorBids[0].r0_price[0].r0_unit_price) || 0),
      0
    );
    return totalUnitRateOfFreightR0.toFixed(2);
  };

  // const renderUnitRateOfTotalUnitRateR0 = (siteLocations, record) => {
  //   return (
  //     <div style={{ display: 'flex',  }}>
  //     {/*  <div style={{ display: 'flex', flexDirection:'column', gap: '10px' }}>
  //       <label>R0</label>
  //       <div style={{ display: 'flex',  }}>
  //         {siteLocations.map((site, siteIndex) => (
  //           <Input
  //             key={site.name + siteIndex}
  //             disabled={enableInputs}
  //             prefix={<RupeesSign />}
  //             style={{  width: '150px' }}
  //             placeholder={`Enter Total`}
  //             value={site.vendorBids[0].r0_price[0].r0_total_price}
  //             onChange={(e) => handleTotalUnitRateR0Change(e.target.value, record.key, siteIndex)}
  //             type="number"
  //           />
  //         ))}
  //         </div>
  //       </div>
  //       <div style={{ display: 'flex',flexDirection:'column', gap: '10px' }}>
  //         <label>R1</label>
  //         <div style={{ display: 'flex',  }}>
  //         {siteLocations.map((site, siteIndex) => (
  //           <Input
  //             key={site.name + siteIndex}
  //             disabled={enableInputs}
  //             prefix={<RupeesSign />}
  //             style={{  width: '150px' }}
  //             placeholder={`Enter Total`}
  //             value={site.vendorBids[0].r0_price[0].r0_total_price}
  //             onChange={(e) => handleTotalUnitRateR0Change(e.target.value, record.key, siteIndex)}
  //             type="number"
  //           />
  //         ))}
  //         </div>
  //       </div>

  //       <div style={{ display: 'flex',flexDirection:'column', gap: '10px'}}>
  //         <label>R</label>
  //         <div style={{ display: 'flex',  }}>
  //         {siteLocations.map((site, siteIndex) => {
  //           console.log('site 66', site, 'siteIndex 66', siteIndex)
  //           if(siteIndex === 0){
  //             return (
  //               <>
  //               <label>Unit Price</label>
  //               <Input
  //             key={site.name + siteIndex}
  //             disabled={enableInputs}
  //             prefix={<RupeesSign />}
  //             style={{  width: '150px' }}
  //             placeholder={`Enter Total`}
  //             value={site.vendorBids[0].r0_price[0].r0_total_price}
  //             onChange={(e) => handleTotalUnitRateR0Change(e.target.value, record.key, siteIndex)}
  //             type="number"
  //           />
  //           </>
  //             )
  //           }
  //           else if(siteIndex === 1){
  //             return (
  //               <>
  //               <label>Total Amount</label>

  //               <Input
  //                 key={site.name + siteIndex}
  //                 disabled={enableInputs}
  //                 prefix={<RupeesSign />}
  //                 style={{  width: '150px' }}
  //                 placeholder={`Enter Total`}
  //                 value={site.vendorBids[0].r0_price[0].r0_total_price}
  //                 onChange={(e) => handleTotalUnitRateR0Change(e.target.value, record.key, siteIndex)}
  //                 type="number"
  //               />
  //               </>
  //             )
  //           }

  //       })
  //       }
  //         </div>
  //     </div> */}
  //     </div>
  //   );
  // };

  const calculateTotalUnitRateOfR0 = (record) => {
    const totalUnitRateOfCementR0 =
      parseFloat(calculateTotalUnitRateOfCementR0(record)) || 0;
    const totalUnitRateOfFreightR0 =
      parseFloat(calculateTotalUnitRateOfFreightR0(record)) || 0;

    return (totalUnitRateOfCementR0 + totalUnitRateOfFreightR0).toFixed(2);
  };

  const renderUnitRateOfCementR1 = (siteLocations, record) => {
    return (
      <>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {siteLocations.map((site, siteIndex) => (
            <Input
              key={site.name + siteIndex}
              prefix={<RupeesSign />}
              disabled
              style={{ width: "100%" }}
              //placeholder={`Enter Unit Rate of Cement for ${site.name}`}
              // value={site.vendorBids[0].r1_price[0].r1_unit_price}
              onChange={(e) =>
                handleUnitRateOfCementChangeR1(
                  e.target.value,
                  record.key,
                  siteIndex
                )
              }
              type="number"
            />
          ))}
          <Input
            // placeholder={`Total Unit Rate of Cement R1`}
            prefix={<RupeesSign />}
            //value={calculateTotalUnitRateOfCementR1(record)} // Assuming unit_rate_of_cement is a property in the record
            style={{ width: "100%" }} // Adjust width as needed
            disabled
          />
        </div>
      </>
    );
  };

  const renderUnitRateOfFreightR1 = (siteLocations, record) => {
    return (
      <>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {siteLocations.map((site, siteIndex) => (
            <Input
              key={site.name + siteIndex}
              prefix={<RupeesSign />}
              disabled
              style={{ width: "100%" }}
              //placeholder={`Enter Unit Rate of Freight for ${site.name}`}
              // value={site.vendorBids[0].r1_price[0].r1_unit_price}
              onChange={(e) =>
                handleUnitRateOfFreightChangeR1(
                  e.target.value,
                  record.key,
                  siteIndex
                )
              }
              type="number"
            />
          ))}
          <Input
            //placeholder={`Total Unit Rate of Freight R1`}
            prefix={<RupeesSign />}
            //   value={calculateTotalUnitRateOfFreightR1(record)} // Assuming unit_rate_of_cement is a property in the record
            style={{ width: "100%" }} // Adjust width as needed
            disabled
          />
        </div>
      </>
    );
  };

  const calculateTotalUnitRateOfFreightR1 = (record) => {
    const totalUnitRateOfFreightR1 = record.siteLocations.reduce(
      (total, site) =>
        total + (parseFloat(site.vendorBids[0].r1_price[0].r1_unit_price) || 0),
      0
    );
    return totalUnitRateOfFreightR1.toFixed(2);
  };

  const renderUnitRateOfTotalUnitRateR1 = (siteLocations, record) => {
    return (
      <>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {siteLocations.map((site, siteIndex) => (
            <Input
              key={site.name + siteIndex}
              prefix={<RupeesSign />}
              disabled
              style={{ width: "100%" }}
              //placeholder={`Enter Total Unit Rate for ${site.name}`}
              // value={site.vendorBids[0].r1_price[0].r1_total_price}
              onChange={(e) =>
                handleTotalUnitRateOfCementR1Change(
                  e.target.value,
                  record.key,
                  siteIndex
                )
              }
              type="number"
            />
          ))}

          <Input
            //placeholder={`Total Unit Rate of R1`}
            prefix={<RupeesSign />}
            // value={calculateTotalUnitRateOfR1(record)} // Assuming unit_rate_of_cement is a property in the record
            style={{ width: "100%" }} // Adjust width as needed
            disabled
          />
        </div>
      </>
    );
  };

  const calculateTotalUnitRateOfR1 = (record) => {
    const totalUnitRateOfCementR1 =
      parseFloat(calculateTotalUnitRateOfCementR1(record)) || 0;
    const totalUnitRateOfFreightR1 =
      parseFloat(calculateTotalUnitRateOfFreightR1(record)) || 0;

    return (totalUnitRateOfCementR1 + totalUnitRateOfFreightR1).toFixed(2);
  };


  const vendorNames = new Set();
  comparativesRFQ.forEach((item) => {
    item.siteLocations.forEach((site) => {
      site.vendorBids.forEach((bid) => {
        vendorNames.add(bid.vendorName);
      });
    });
  });

  [...vendorNames].map((vendorName, index) => {
  });

  const vendorColumns = [...vendorNames].map((vendorName) => ({
    title: vendorName,
    className: "secondth",
    children: [
      !hideInitialBidPrice && {
        title: "R0",
        className: "thirdth",
        children: [
          {
            title: "Unit Price",
            className: "fourth",
            dataIndex: "siteLocations",
            render: (siteLocations, record) => {
              return (
                <>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                    }}
                  >
                    {siteLocations.map((site, index) => (
                      <div key={index}>
                        <div key={index}>
                          <Input
                            key={index}
                            disabled
                            style={{ width: "100%" }}
                            // placeholder={`Enter Unit Rate of Cement for ${ven.name}`}
                            // value={site.vendorBids[0].r0_price[0].r0_unit_price}
                            value={
                              site.vendorBids.find(
                                (bid) => bid.vendorName === vendorName
                              )?.r0_price[0]?.r0_unit_price || ""
                            }
                            // value={record.siteLocations.find()}

                            type="number"
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              );
            },
          },
          {
            title: "Total Amount",
            className: "fourth",
            dataIndex: "siteLocations",
            render: (siteLocations, record) => (
              <>
                {/*vendors(siteLocations, record)*/}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  {siteLocations.map((site, index) => (
                    <div key={index}>
                      <div key={index}>
                        <Input
                          key={index}
                          disabled
                          style={{ width: "100%" }}
                          // placeholder={`Enter Unit Rate of Cement for ${ven.name}`}
                          // value={ven.vendorBids[0].r0_price[0].r0_unit_price}
                          // onChange={(e) => handleUnitRateOfCementChangeR0(e.target.value, record.key, index, ven.vendorBids[0].gst_rate, ven.quantity)}
                          value={
                            site.vendorBids.find(
                              (bid) => bid.vendorName === vendorName
                            )?.r0_price[0]?.r0_total_price || ""
                          }
                          type="number"
                        />
                        {/* Include additional vendor information here */}
                      </div>
                    </div>
                  ))}
                </div>
              </>
            ),
          },
        ],
      },
      !hideR1BidPrice && {
        title: "R1",
        className: "thirdth",
        children: [
          {
            title: "Unit Price",
            className: "fourth",
            dataIndex: "siteLocations",
            render: (siteLocations, record) => (
              <>
                {/*vendors(siteLocations, record)*/}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  {siteLocations.map((site, index) => (
                    <div key={index}>
                      <div key={index}>
                        <Input
                          key={index}
                          disabled
                          style={{ width: "100%" }}
                          value={
                            site.vendorBids.find(
                              (bid) => bid.vendorName === vendorName
                            )?.r1_price[0]?.r1_unit_price || ""
                          }
                          type="number"
                        />
                        {/* Include additional vendor information here */}
                      </div>
                    </div>
                  ))}
                </div>
              </>
            ),
          },
          {
            title: "Total Amount",
            className: "fourth",
            dataIndex: "siteLocations",
            render: (siteLocations, record) => (
              <>
                {/*vendors(siteLocations, record)*/}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  {siteLocations.map((site, index) => (
                    <div key={index}>
                      <div key={index}>
                        <Input
                          key={index}
                          disabled
                          style={{ width: "100%" }}
                          value={
                            site.vendorBids.find(
                              (bid) => bid.vendorName === vendorName
                            )?.r1_price[0]?.r1_total_price || ""
                          }
                          type="number"
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </>
            ),
          },
        ],
      },
      !hideRBidPrice && {
        title: "R",
        className: "thirdth",
        children: [
          {
            title: "Unit Price",
            className: "fourth",
            dataIndex: "siteLocations",
            render: (siteLocations, record) => (
              <>
                {/*vendors(siteLocations, record)*/}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  {siteLocations.map((site, index) => (
                    <div key={index}>
                      <div key={index}>
                        <Input
                          key={index}
                          disabled
                          style={{ width: "100%" }}
                          value={
                            site.vendorBids.find(
                              (bid) => bid.vendorName === vendorName
                            )?.r_price[0]?.r_unit_price || ""
                          }
                          type="number"
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </>
            ),
          },
          {
            title: "Total Amount",
            className: "fourth",
            dataIndex: "siteLocations",
            render: (siteLocations, record) => (
              <>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  {siteLocations.map((site, index) => (
                    <div key={index}>
                      <div key={index}>
                        <Input
                          key={index}
                          disabled
                          style={{ width: "100%" }}
                          value={
                            site.vendorBids.find(
                              (bid) => bid.vendorName === vendorName
                            )?.r_price[0]?.r_total_price || ""
                          }
                          type="number"
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </>
            ),
          },
        ],
      },
    ].filter(Boolean),
  }));

  const handleExcelDownload = async () => {
    const endpoint = `comparative-rfq/${id}/comparative-excel-download/`;
    const fileType = "csv";

    try {
      //setBtnloading(true);
      await getRequest(endpoint)
        .then((response) => {
          const blob = new Blob([response.data], {
            type: "text/csv",
          });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          //link.download = `purchase_requisition_${id}-${+new Date()}.${fileType}`;
          link.download = `comparatives-rfq_${+new Date()}.${fileType}`;
          link.click();
          //setBtnloading(false);
        })
        .catch((error) => {
          //ErrorNotificationMsg(t(`err_${fileType}_download`));
        });
    } catch (error) {
      //setBtnloading(false);
      //ErrorNotificationMsg(error);
    }
  };

  const columns = [
    {
      title: "SR.",
      dataIndex: "key",
      fixed: "left",
      width: 80,
      render: (text, record, index) => (
        <div className="lblvalue">{index + 1}</div>
      ),
    },

    {
      title: "Site",
      dataIndex: "siteName",
      key: "siteName",
      fixed: "left",
      width: 90,
    },

    {
      title: "Item",
      dataIndex: "siteLocations",
      fixed: "left",
      width: 90,
      render: (siteLocations) => (
        <>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            {siteLocations.map((site, index) => (
              <div key={index} className="lblvalue">
                {site.materialName}
              </div>
            ))}
          </div>
        </>
      ),
    },
    {
      title: "Quantity",
      width: 90,
      dataIndex: "siteLocations",
      render: (siteLocations) => (
        <>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            {siteLocations.map((site, index) => (
              <div key={index} className="lblvalue">
                {site.quantity}
              </div>
            ))}
          </div>
        </>
      ),
    },
    {
      title: "UOM",
      width: 90,
      dataIndex: "siteLocations",
      render: (siteLocations) => (
        <>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            {siteLocations.map((site, index) => (
              <div key={index} className="lblvalue">
                {site.uom}
              </div>
            ))}
          </div>
        </>
      ),
    },
    // {
    //   title: 'PO & Date',
    //   dataIndex: 'siteLocations',
    //   render: (siteLocations, record) => renderUnitRateOfCementR0(siteLocations, record)
    // },
    //   {
    //     title: 'LPP [Last Purchase Price]',
    //     children: [
    //         {
    //             title: 'Last Order Detail',
    //             children: [
    //                 {
    //                     title: 'PO & Date',
    //                     dataIndex: 'siteLocations',
    //                     // hidden: hideUnitRateOfCementR0,
    //                     // render: (siteLocations, record) => renderUnitRateOfCementR0(siteLocations, record)
    //                     render: (siteLocations, record) => {
    //                         console.log(siteLocations, siteLocations)
    //                         return renderDateR0(siteLocations, record); // Otherwise, render the column content
    //                     }
    //                 },
    //                 {
    //                     title: 'Vendor Name',
    //                     dataIndex: 'siteLocations',
    //                     // hidden: hideUnitRateOfCementR0,
    //                     render: (siteLocations, record) => renderVendorName(siteLocations, record)
    //                 },
    //                 {
    //                     title: 'Unit Price',
    //                     dataIndex: 'siteLocations',
    //                     // hidden: hideUnitRateOfCementR0,
    //                     render: (siteLocations, record) => {
    //                         return renderUnitRateOfTotalUnitRateR0(siteLocations, record); // Otherwise, render the column content
    //                     }
    //                 },
    //             ]
    //         },
    //         {
    //             title: 'Last 30 Days Avg. Price',
    //             children: [
    //                 {
    //                     title: 'INR',
    //                     dataIndex: 'siteLocations',
    //                     // hidden: !showUnitRateCementR1 || hideUnitRateOfCementR1,
    //                     render: (siteLocations, record) => {
    //                         return renderUnitRateOfCementR1(siteLocations, record); // Otherwise, render the column content
    //                     }
    //                 },
    //             ]
    //         },
    //         {
    //             title: 'Item Wise L1',
    //             children: [
    //                 {
    //                     title: 'INR',
    //                     dataIndex: 'siteLocations',
    //                     //hidden: !showUnitRateCementR1 || hideUnitRateOfCementR1,
    //                     render: (siteLocations, record) => {
    //                         return renderUnitRateOfFreightR1(siteLocations, record); // Otherwise, render the column content
    //                     }
    //                 },
    //             ]
    //         },
    //         {
    //             title: 'Last 30 Days Avg. Price On Smart Buyer',
    //             children: [
    //                 {
    //                     title: 'INR',
    //                     dataIndex: 'siteLocations',
    //                     // hidden: !showUnitRateCementR1 || hideUnitRateOfCementR1,
    //                     render: (siteLocations, record) => {
    //                         return renderUnitRateOfTotalUnitRateR1(siteLocations, record); // Otherwise, render the column content
    //                     }
    //                 },
    //             ],
    //             width: 350,
    //         },
    //     ]
    // },
    {
      title: "LPP [Last Purchase Price]",
      className: "secondth",
      children: [
        {
          title: "Last Order Detail",
          className: "thirdth",
          children: [
            {
              title: "PO & Date",
              className: "fourth",
              dataIndex: "siteLocations",
              //hidden: hideUnitRateOfCementR0,
              // render: (siteLocations, record) => renderUnitRateOfCementR0(siteLocations, record)
              render: (siteLocations, record) => {
                return renderDateR0(siteLocations, record); // Otherwise, render the column content
              },
            },
            {
              title: "Vendor",
              className: "fourth",
              dataIndex: "siteLocations",
              // hidden: hideUnitRateOfCementR0,
              render: (siteLocations, record) =>
                renderVendorName(siteLocations, record),
            },
            {
              title: "Unit Price",

              dataIndex: "siteLocations",
              // hidden: hideUnitRateOfCementR0,
              render: (siteLocations, record) => {
                return renderUnitRateOfTotalUnitRateR0(siteLocations, record); // Otherwise, render the column content
              },
            },
          ],
        },
        {
          title: "Last 30 Days Avg. Price",
          className: "thirdth",
          children: [
            {
              title: "INR",
              className: "fourth",
              dataIndex: "siteLocations",
              // hidden: !showUnitRateCementR1 || hideUnitRateOfCementR1,
              render: (siteLocations, record) => {
                return renderUnitRateOfCementR1(siteLocations, record); // Otherwise, render the column content
              },
            },
          ],
        },
        {
          title: "Item Wise L1",
          className: "thirdth",
          children: [
            {
              title: "INR",
              className: "fourth",
              dataIndex: "siteLocations",
              //hidden: !showUnitRateCementR1 || hideUnitRateOfCementR1,
              render: (siteLocations, record) => {
                return renderUnitRateOfFreightR1(siteLocations, record); // Otherwise, render the column content
              },
            },
          ],
        },
        {
          title: "Last 30 Days Avg. Price On Smart Buyer",
          className: "thirdth",
          children: [
            {
              title: "INR",
              className: "fourth",
              dataIndex: "siteLocations",
              // hidden: !showUnitRateCementR1 || hideUnitRateOfCementR1,
              render: (siteLocations, record) => {
                return renderUnitRateOfTotalUnitRateR1(siteLocations, record); // Otherwise, render the column content
              },
            },
          ],
        },
      ],
    },

    ...vendorColumns,
  ];

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>Comparatives - Site Wise</h3>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="">Home</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/request-for-quotation/history">RFQ History</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>Comparatives - Site Wise</Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div>

      <section className="grid-sec mt-5">
        <div className="PR-body">
          <div className="rgq-num-wrap">
            <div className="bidleftfilters">
              <h5 className="rfq-number new">
                RFQ Number : <span>{rfqNumber}</span>
              </h5>
              <Checkbox
                checked={hideInitialBidPrice}
                onChange={handleCheckboxhideR1}
              >
                Hide Initial BID Price - R0
              </Checkbox>
              <Checkbox checked={hideR1BidPrice} onChange={handleCheckboxhideR}>
                Hide BID Price - R1
              </Checkbox>
              <Checkbox checked={hideRBidPrice} onChange={handleCheckboxhideRR}>
                Hide BID Price - R
              </Checkbox>
              <Checkbox>Show Last Quoted Price</Checkbox>
              <Form.Item
                name="site_name"
                label=""
                //prefix={<User />}
              >
                <Select
                  showArrow
                  mode="multiple"
                  showSearch
                  allowClear
                  placeholder="Select Site Name"
                  optionFilterProp="children"
                  onChange={handleSiteNameSelectChange}
                  value={state.site_id}
                >
                  {siteName.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                name="material_type"
                label=""
                //prefix={<User />}
              >
                <Select
                  showArrow
                  mode="multiple"
                  showSearch
                  allowClear
                  placeholder="Select Material Name"
                  optionFilterProp="children"
                  onChange={handleMaterialSelectChange}
                >
                  {materialName.map((material) => (
                    <Option key={material.id} value={material.id}>
                      {material.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <FilterFilled className="fltrbtn" />
            </div>
            <div className="btnwrp2">
              <ButtonField
                className="SaveGradiantBtn"
                type="primary"
                htmlType="Excel"
                label="Excel"
                onClick={handleExcelDownload}
                icon={<img src={ExelDownload} alt="Plus Square" />}
              />
              <ButtonField
                className="SaveGradiantBtn"
                type="primary"
                // htmlType="Submit"
                label="View Items Wise"
                onClick={() =>
                  navigate(
                    `/request-for-quotation/material-wise-comparatives/${id}`
                  )
                }
                //loading={btnLoading}
              />
            </div>
          </div>

          {/* <Form autoComplete="off" ref={formRef} > */}
          <Spin spinning={apiLoading} >
            <Table
              dataSource={comparativesRFQ}
              bordered
              scroll={{
                x: 4500,
              }}
              columns={columns}
              className="comparativecustomtbl"
              pagination={false}
            />
          </Spin>
          <div className="btnwrp2" style={{ paddingTop: "16px" }}>
            <ButtonField
              className="SaveGradiantBtn"
              type="primary"
              // htmlType="Submit"
              label="RFQ Review"
              onClick={() =>
                navigate(`/request-for-quotation/summarypricecomparatives/`)
              }
              //loading={btnLoading}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default Comparatives;
